const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class FourCta extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.classList.contains('sec-FourCta-stack')) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 'auto',
              spacing: 32,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('four-cta')) {
  customElements.define('four-cta', FourCta)
}
